import { Col, Row } from 'antd'
import './MultiPosTable.style.less'
import { isEmpty, uniqWith, isEqual } from 'lodash'

function MultiPosTable({ data }: any) {
  const findMasterPOandDepartment = () => {
    const getOrders = isEmpty(data.orders) ? [data.order] : data.orders
    const result = getOrders?.map((item) => {
      const findPropertyValue = (name) => {
        return item?.property_values?.find((val) => val?.field == name)?.value
      }
      const masterOrderValue = findPropertyValue('masterOrder')
      const ftpoValue = findPropertyValue('ftpo')
      const masterPo = masterOrderValue || ftpoValue || '-'

      const department = !findPropertyValue('deptNum')
        ? '-'
        : `${findPropertyValue('deptNum')}`

      return {
        masterPo,
        department,
      }
    })
    return uniqWith(result, isEqual)
  }

  return (
    <div className="multi-po-table-container">
      <Row>
        <Col span={6}>
          <p className="title">Master PO</p>
        </Col>
        <Col span={18}>
          <p className="title">Department</p>
        </Col>
      </Row>
      {findMasterPOandDepartment()?.map((item, index) => {
        return (
          <Row key={index} className="multi-po-data-container">
            <Col span={6}>
              <p className="label">{item?.masterPo}</p>
            </Col>
            <Col span={18}>
              <p className="value">{item?.department}</p>
            </Col>
          </Row>
        )
      })}
    </div>
  )
}

export default MultiPosTable
